import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Authentication from '../../components/Authentication';

const mapStateToProps = (state: StoreState) => {
	return {
		authentication: state.authentication,
		galleryInfos: state.galleryInfos,
	};
};

export default connect(mapStateToProps)(Authentication);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Authentication/index.tsx